let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iFZBi")).then(() => parcelRequire('hY7nq'));